import "./EditEquipmentCredentials.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditEquipmentCredentialsComponentController from "./EditEquipmentCredentialsComponentController";

export default class EditEquipmentCredentialsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditEquipmentCredentialsComponentController;
        this.templateUrl =
            "/App/Components/Site/DesignAndPlanning/" +
            "SelectedEquipment/EquipmentDetails/EditCredentials/EditEquipmentCredentials.html";
    }
}

module("mmManagePortal").component("irEditEquipmentCredentials", new EditEquipmentCredentialsComponent());
